'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3;

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ReportPageStore = (0, _classAutobindDecorator2.default)(_class = (_class2 = function () {
  function ReportPageStore() {
    _classCallCheck(this, ReportPageStore);

    _initDefineProp(this, 'filters', _descriptor, this);

    _initDefineProp(this, 'ordering', _descriptor2, this);

    _initDefineProp(this, 'fields', _descriptor3, this);
  }

  _createClass(ReportPageStore, [{
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'asJSON',
    get: function get() {
      return {
        fields: (0, _mobx.toJS)(this.fields),
        filters: (0, _mobx.toJS)(this.filters),
        ordering: (0, _mobx.toJS)(this.ordering)
      };
    }
  }]);

  return ReportPageStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'filters', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'ordering', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'fields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'asJSON', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'asJSON'), _class2.prototype)), _class2)) || _class;

var _default = ReportPageStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ReportPageStore, 'ReportPageStore', '/app/src/stores/ReportPageStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/ReportPageStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9zdG9yZXMvUmVwb3J0UGFnZVN0b3JlLmpzIl0sIm5hbWVzIjpbIlJlcG9ydFBhZ2VTdG9yZSIsImF1dG9CaW5kTWV0aG9kcyIsImZpZWxkcyIsImZpbHRlcnMiLCJvcmRlcmluZyIsIm9ic2VydmFibGUiLCJjb21wdXRlZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7OztBQUFBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFHTUEsZSxPQURMQyxnQzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7d0JBT2U7QUFDWixhQUFPO0FBQ0xDLGdCQUFRLGdCQUFLLEtBQUtBLE1BQVYsQ0FESDtBQUVMQyxpQkFBUyxnQkFBSyxLQUFLQSxPQUFWLENBRko7QUFHTEMsa0JBQVUsZ0JBQUssS0FBS0EsUUFBVjtBQUhMLE9BQVA7QUFLRDs7Ozs2RUFYQUMsZ0I7OztXQUFxQixFOzs2RUFDckJBLGdCOzs7V0FBc0IsRTs7MkVBQ3RCQSxnQjs7O1dBQW9CLEU7OzREQUVwQkMsYzs7ZUFVWU4sZTs7Ozs7Ozs7Ozs7MEJBZlRBLGUiLCJmaWxlIjoiUmVwb3J0UGFnZVN0b3JlLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBvYnNlcnZhYmxlLCBjb21wdXRlZCwgdG9KUyB9IGZyb20gJ21vYngnO1xuaW1wb3J0IGF1dG9CaW5kTWV0aG9kcyBmcm9tICdjbGFzcy1hdXRvYmluZC1kZWNvcmF0b3InO1xuXG5AYXV0b0JpbmRNZXRob2RzXG5jbGFzcyBSZXBvcnRQYWdlU3RvcmUge1xuICBAb2JzZXJ2YWJsZSBmaWx0ZXJzID0ge307XG4gIEBvYnNlcnZhYmxlIG9yZGVyaW5nID0gW107XG4gIEBvYnNlcnZhYmxlIGZpZWxkcyA9IFtdO1xuXG4gIEBjb21wdXRlZFxuICBnZXQgYXNKU09OICgpIHtcbiAgICByZXR1cm4ge1xuICAgICAgZmllbGRzOiB0b0pTKHRoaXMuZmllbGRzKSxcbiAgICAgIGZpbHRlcnM6IHRvSlModGhpcy5maWx0ZXJzKSxcbiAgICAgIG9yZGVyaW5nOiB0b0pTKHRoaXMub3JkZXJpbmcpLFxuICAgIH07XG4gIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgUmVwb3J0UGFnZVN0b3JlO1xuIl19